<template>
  <path
    d="M9 4.00018C9 2.89018 9.89 2.00018 11 2.00018C12.11 2.00018 13 2.89018 13 4.00018C13 5.11018 12.11 6.00018 11 6.00018C9.89 6.00018 9 5.11018 9 4.00018ZM16 13.0002C15.99 11.6602 15.17 10.4902 14 10.0002C14 8.29018 12.58 6.92018 10.84 7.00018C9.22 7.09018 8 8.54018 8 10.1602V16.0002C8 16.5502 8.45 17.0002 9 17.0002H10V20.5002C10 21.3302 10.67 22.0002 11.5 22.0002C12.33 22.0002 13 21.3302 13 20.5002V17.0002H15C15.55 17.0002 16 16.5502 16 16.0002V13.0002Z"
  />
</template>
